import { brandPrimaryHover, header } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		':hover': {
			border: `1px solid ${brandPrimaryHover}`,
		},
		background: '#fff',
		border: '1px solid #D3DBDE',
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.30)',
		cursor: 'pointer',
		height: 300,
		width: 278,
	},
	description: {
		boxSizing: 'border-box',
		color: header,
		fontSize: 12,
		padding: '0 20px',
		...CssSelectors.allChildren({
			listStylePosition: 'inside',
			listStyleType: 'disc',
		}),
		...CssSelectors.allChildren(
			{
				marginTop: 4,
			},
			':not(:first-child)'
		),
	},
	divider: {
		background: '#858585',
		height: 2,
		width: '100%',
	},
	image: {
		alignItems: 'center',
		display: 'flex',
		height: '60%',
		justifyContent: 'center',
	},
	title: {
		fontSize: 16,
		padding: 10,
	},
});
